import { createPaginator } from '@orange-marmalade/paginate-this';
import { fromJS, Record } from 'immutable';
import PaginateThisDuckCreator from '../middleware/paginate-this';
import { api, cleanQuery, formatError } from '../middleware/client';

const BASE_URL = `${process.env.REACT_APP_REST_URI}/designations`;
const locator = ({ DesignationSearch }) => DesignationSearch.get('list');
const listId = 'designations';
const defaultQuery = {
  page: 1,
  pageSize: 1000
};

const DesignationRecord = Record({
  code: '',
  abbr: '',
  title: '',
  description: '',
  dateAdded: undefined,
  designationImage: '',
  designationURL: ''
});

const paginateReducer = createPaginator({
  listId,
  fetch,
  locator,
  cache: true,
  initialSettings: {
    // initialized is true to prevent extra actions being fired
    // since we actually initialize the list using query parameters
    initialized: true,
    ...defaultQuery
  }
});

const initialState = fromJS({
  list: paginateReducer()
});

function reducer(state = initialState, action) {
  state = state.setIn(['list'], paginateReducer.call(this, state.get('list'), action));
  return state;
}

function fetch(params) {
  const { query } = params;

  return api
    .get(BASE_URL, {
      query: cleanQuery({
        ...query,
        page: undefined,
        pageSize: undefined,
        offset: query.pageSize * (query.page - 1),
        limit: query.pageSize
      })
    })
    .then(function (response) {
      return {
        data: {
          results: response.list,
          total_count: response.total
        }
      };
    })
    .catch(error => {
      throw formatError(error);
    });
}

const paginateThis = new PaginateThisDuckCreator({
  listId,
  locator,
  defaultQuery,
  // Lists filters that will automatically get parsed from the query string
  availableFilters: {}
});

export { paginateThis, fetch, DesignationRecord };
export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/DesignationSearch.js